import * as z from "zod";
import { AreasField } from "@/pages/requests/components/areas/types";

export const AreaFieldSchema = z.object({
  Id: z.number(),
  CompanyId: z.number(),
  CicpaCode: z.number(),
  AreaNameEn: z.string(),
  AreaNameAr: z.string(),
  Value: z.string(),
  CompanyNameAr: z.string(),
  CompanyNameEn: z.string(),
  AreaLocation: z.string(),
  IsVisible: z.boolean(),
  Company: z.object({
    Id: z.number(),
    CompanyNameAr: z.string(),
    CompanyNameEn: z.string(),
    ActivityAr: z.string(),
    ActivityEn: z.string(),
    OilNumber: z.number(),
    Visible: z.boolean(),
    Value: z.string(),
  }),
});

export const AreasFieldLocationFormDataSchema = z.object({
  [AreasField.Location]: AreaFieldSchema,
  [AreasField.Areas]: AreaFieldSchema,
});

export const AreasFieldsLocationSchema = z.object({
  [AreasField.Location]: z.array(AreaFieldSchema).default([]),
});
